<template>
  <picture>
    <source
      type="image/webp"
      :srcset="`
        /img/hello/figure/spiral.webp 250w,
        /img/hello/figure/spiral@2.webp 500w,
        /img/hello/figure/spiral@4.webp 1000w
      `"
      sizes="(max-width: 400px) 250px, (max-width: 800px) 500px, 1000px"
    >

    <img
      :src="`/img/hello/figure/spiral.png`"
      :srcset="`
        /img/hello/figure/spiral.png 250w,
        /img/hello/figure/spiral@2.png 500w,
        /img/hello/figure/spiral@4.png 1000w
      `"
      sizes="(max-width: 400px) 250px, (max-width: 800px) 500px, 1000px"
      loading="lazy"
      decoding="async"
    >
  </picture>
</template>


<script>
export default {
  name: 'HelloFigure',
};
</script>


<style lang="scss" scoped>
picture {
  display: block;
  aspect-ratio: 1;
  position: absolute;
  max-width: var(--max-width);
  pointer-events: none;
  user-select: none;
  line-height: 0;

  &::after {
    content: "";
    inset: 0;
    position: absolute;
    mask-image: url('/img/hello/figure/spiral@4.webp');
    -webkit-mask-image: url('/img/hello/figure/spiral@4.webp');
    mask-repeat: no-repeat;
    -webkit-mask-repeat: no-repeat;
    mask-size: contain;
    -webkit-mask-size: contain;
    mask-position: center;
    -webkit-mask-position: center;
    mix-blend-mode: hard-light;
    background: linear-gradient(var(--rotate-gradient, 180deg), #4D43C6 25%, var(--color-primary) 70%);
    opacity: .75;
  }

  img {
    max-width: inherit;
    max-height: inherit;
    aspect-ratio: inherit;
  }
}
</style>